export class MenuOpen {
	constructor(header) {
		this.header    = header;
		this.nav       = header.querySelector('nav');
		this.inquiry = 	this.nav.querySelector('a[href="#poptavka"]');
		this.menu      = header.querySelector('#menu-primary-menu');
		this.hamburger = header.querySelector('#hamburger');
		this.subItem   = this.menu.querySelectorAll('li.has-sub');
		this.active    = 'active';

		if(this.subItem.length) {
			for(let i = 0; i < this.subItem.length; i++) {
				this.subButton = this.subItem[i];
				this.subCotent = this.subItem[i].querySelector('.submenu');

				if(this.subButton && this.subCotent) {
					this.initAddListenerSub(this.subButton, this.subCotent);
				}
			}
		}

		if(this.hamburger) {
			this.initAddListner();
		}

		if(this.inquiry) {
			this.inquiry.addEventListener('click', this.closeMenuMobile.bind(this));
		}
	}

	initAddListner() {
		this.hamburger.addEventListener('click', this.eventClickMenu.bind(this, this.nav));
		document.body.addEventListener('click', this.clickOutsideSubMenu.bind(this));
	}

	initAddListenerSub(subButton, subContent) {
		subButton.addEventListener('click', this.eventClickMenuSub.bind(this, subButton, subContent));
		// subButton.addEventListener('mouseover', this.mouseOnMenu.bind(this, subButton, subContent));
	}

	eventClickMenu(content, e) {
		if(content.classList.contains(this.active)) {
			this.removeActive(content);
			this.removeActive(e.target);
			this.removeActive(e.target.parentElement);
		} else {
			this.addActive(content);
			this.addActive(e.target);
			this.addActive(e.target.parentElement);
		}
	};

	closeMenuMobile() {
		if(this.nav.classList.contains(this.active) && this.hamburger.classList.contains(this.active)) {
			this.removeActive(this.nav);
			this.removeActive(this.hamburger);
		}
	}

	mouseOnMenu(content, submenu) {
		if(!content.classList.contains(this.active)) {
			this.addActive(content);
			this.addActive(submenu);
		}
	}

	eventClickMenuSub(button ,content, e) {

		const mediaQueryList = window.matchMedia('(max-width: 1199px)');
		const resizes = (mediaQueryList) => {
			if(mediaQueryList.matches) {
				if(content.classList.contains(this.active)) {
					if(!content.contains(e.target)) {
						this.removeActive(content);
						this.removeActive(button);
					}
				} else {
					this.addActive(content);
					this.addActive(button);
				}
			}
		};
		resizes(mediaQueryList);
		mediaQueryList.addListener(resizes);


	}

	addActive(element) {
		element.classList.add(this.active);
	}

	removeActive(element) {
		element.classList.remove(this.active);
	}

	clickOutsideSubMenu(e) {
		for(let i = 0; i < this.subItem.length; i++) {
			let submenu = this.subItem[i].querySelector('.submenu.active');
			let button = this.subItem[i];

			if(submenu) {
				if(!submenu.contains(e.target) && !button.contains(e.target)) {
					this.removeActive(submenu);
					this.removeActive(button);
				}
			}
		}
	}
}